export default __webpack_public_path__ + "static/media/T680_C_BD.c0b3a953.pdf";